// extracted by mini-css-extract-plugin
module.exports = {"container":"RouteLayout_container__1a-cW","title":"RouteLayout_title__M0eNR"};